export const DataRecrutement = {
  sectionName: "REJOIGNEZ-NOUS",
  desc: "Nous sommes toujours à la recherche de nouveaux talents pour rejoindre notre équipe. Nous offrons un environnement de travail dynamique et stimulant où vous pourrez développer vos compétences et contribuer à des projets passionnants. Si vous êtes intéressé par une carrière chez SETELEC, veuillez nous envoyer votre CV et votre lettre de motivation.",
  formTitle: "",
  formSubtitle: "",
};
